import { ThemeConfig } from "react-select";
export const selectTheme: ThemeConfig = (theme) => ({
    ...theme,
    borderRadius: 3,
    colors: {
        ...theme.colors,
        neutral12: "#e4e4e4",
        // primary75: 'hsl(359, 75%, 59%)',
        // primary50: 'hsl(359, 50%,59%)',
        // primary25: 'hsl(359, 25%, 59%)',
        primary90: "hsl(359, 78%, 90%)",
        primary75: "hsl(359, 78%, 75%)",
        primary50: "hsl(359, 78%, 50%)",
        primary25: "hsl(359, 78%, 25%)",
        primary: "hsl(359, 78%, 59%)"
    }
});

export const styles = {
    container: (provided, props) => {
        return {
            ...provided,
            
        };
    },
    menuPortal: (provided, props) => {
        return {
            ...provided
        };
    },
    dropdownIndicator: (provided, props) => {
        return {
            ...provided,
            paddingLeft: "12px",
            paddingRight: "12px",
            color: "#bbbbbb"
        };
    },
    control: (provided, props) => {
        const ret = {
            ...provided,
            height: 48,
            borderColor: !props.isFocused
                ? props.theme.colors.neutral12
                : props.theme.colors.neutral20,
            boxShadow: props.isFocused
                ? `${props.theme.colors.neutral12} 0px 0px 0px 1px`
                : undefined,
            "&:hover": {
                borderColor: props.theme.colors.neutral20
            }
        };
        return ret;
    },
    singleValue: (provided, props) => {
        return {
            ...provided,
            color: undefined,
            marginLeft: "16px",
            fontSize: "14px",
            letterSpacing: "0.025rem"
        };
    },
    placeholder: (provided, props) => {
        return {
            ...provided,
            color: "#999999",
            marginLeft: "16px",
            fontSize: "14px",
            letterSpacing: "0.025rem"
        };
    },
    option: (provided, props) => {
        const ret = {
            ...provided,
            backgroundColor: "transparent",
            color: props.isSelected ? props.theme.colors.primary50 : undefined,
            fontWeight: props.isSelected ? "bold" : undefined,
            paddingLeft: "25px",
            fontSize: "14px",
            letterSpacing: "0.025rem",
            "&:hover": {
                color: props.theme.colors.primary50
            },
            ":active": {}
        };
        return ret;
    }
};
